var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnchainVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.97168V7.62207C13 10.0807 11.8303 12.3929 9.84961 13.8496L6.5 16.3135L3.15039 13.8496C1.16972 12.3929 0 10.0807 0 7.62207L0 1.97168L6.5 0.500977L13 1.97168Z",
    fill: "#086DE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48218 7.67383L5.63154 9.83442C5.69005 9.89324 5.78495 9.89447 5.84422 9.83717L10.0942 5.72847",
    stroke: "white",
    strokeWidth: 2.14164
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnchainVerified);
export default __webpack_public_path__ + "static/media/onchain_verified.dc88ce87d108fedf0e06744e88d014b7.svg";
export { ForwardRef as ReactComponent };